export const waringIcon = {
	Exclamation: 0, // ⚠️ 驚嘆號（預設）
	Check: 1,       // ✔️ 勾勾
	Cross: 2        // ❌ 叉叉
};

export default {
	waringIcon
};
